/** @format */

import React, { FunctionComponent, ReactElement } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import { useSimCardServiceGroupList } from '../../modules/lib/hooks/useSimCardServiceGroupList';
import { ServicesByGroup } from './ServicesByGroup';
import { ComponentParam } from './component/ComponentByGroup';

type ServicesNotActiveListType = {
    operatorTypes: Array<number>;
    addCallback(componentParams: ComponentParam): void;
    platformResellerId?: number | null;
    isVc?: boolean;
};

export const ServicesNotActiveList: FunctionComponent<ServicesNotActiveListType> = ({
    operatorTypes,
    addCallback,
    platformResellerId,
    isVc,
}): ReactElement => {
    const simCardServicesGroups = useSimCardServiceGroupList(operatorTypes);

    return (
        <GridContainer>
            {simCardServicesGroups &&
                simCardServicesGroups['hydra:member'].map((group) => {
                    return (
                        <ServicesByGroup
                            key={'services_by_group_' + group.id}
                            addCallback={addCallback}
                            simCardServicesGroup={group}
                            operatorTypes={operatorTypes}
                            platformResellerId={platformResellerId}
                            isVc={isVc}
                        />
                    );
                })}
        </GridContainer>
    );
};
